import { IVConditionFilterV2 } from "../../api/groupCustomerV2/groupCustomerV2Api";
import { API_URL_v3 } from "../../env";
import axiosClient from "../axiosClient";
import dayjs from "dayjs";

const axiosClientList = axiosClient(API_URL_v3);

interface CustomerFieldV2 {
  value: number
  label: string
  inputType: string
  type: number
  fieldCode: string
}

interface ISelectOption {
  value: number;
  label: string;
}

interface IConditionSync {
  logicOperator: 'AND' | 'OR' | 'ALL'
  CustomerField?: CustomerFieldV2
  condition?: ISelectOption // value, label


  //nơi lưu giá trị
  value?: {
    valueText?: string | null
    valueNumber?: number | null
    valueNumberMin?: number | null
    valueNumberMax?: number | null
    valueDate?: string | null
    valueDateStart?: string | null
    valueDateEnd?: string | null
    options?: ISelectOption[] | null
  } | null
}


//
export interface ResponseSuccessTotal {
  status: "success" | string
  matched_customers: number[]
  unmatched_customers: number[]
  summary: Summary
  pagination: Pagination
  applied_filters: AppliedFilter[]
  request_params: RequestParams
}

export interface Summary {
  total_customers: number
  total_matched_count: number
  total_unmatched_count: number
  returned_matched_count: number
  returned_unmatched_count: number
}

export interface Pagination {
  offset: number
  limit: number
  matched_pagination: MatchedPagination
  unmatched_pagination: UnmatchedPagination
}

export interface MatchedPagination {
  current_page: number
  total_pages: number
  has_next: boolean
  has_prev: boolean
  total_items: number
}

export interface UnmatchedPagination {
  current_page: number
  total_pages: number
  has_next: boolean
  has_prev: boolean
  total_items: number
}

export interface AppliedFilter {
  logicOperator: string
  fieldCode: string
  condition: Condition
  value: Value
}

export interface Condition {
  value: number
}

export interface Value {
  options: Option[]
}

export interface Option {
  value: number
  label: string
}

export interface RequestParams {
  offset: number
  limit: number
  returnMatched: boolean
  returnUnmatched: boolean
  original_listFilter: OriginalListFilter[]
}

export interface OriginalListFilter {
  logicOperator: string
  CustomerField: CustomerField
  condition: Condition2
  value: Value
}

export interface CustomerField {
  value: number
  label: string
  inputType: string
  fieldCode: string
}

export interface Condition2 {
  value: number
  label: string
}


export const formatConditionValueDate = (value: any) => {
  if (!value || typeof value !== "object") {
    return value;
  }

  return {
    ...value,

    ...(value.valueDate && {
      valueDate: dayjs(value.valueDate, "DD/MM/YYYY").format("YYYY-MM-DD"),
    }),

    ...(value.valueDateStart && {
      valueDateStart: dayjs(value.valueDateStart, "DD/MM/YYYY").format("YYYY-MM-DD"),
    }),

    ...(value.valueDateEnd && {
      valueDateEnd: dayjs(value.valueDateEnd, "DD/MM/YYYY").format("YYYY-MM-DD"),
    }),
  };
};

export const filterInfoOperatoToConditions = (
  infoOperatorTmp: IVConditionFilterV2
): IConditionSync[] => {
  return infoOperatorTmp.conditions
    .filter(condition => condition.isAdd) // Lọc các item có isAdd = true
    .map<IConditionSync>(
      ({
        isAdd: _omitIsAdd,      // loại bỏ isAdd
        optionsData: _omitOptionsData, // loại bỏ optionsData
        ...rest
      }) => ({
        logicOperator: rest.logicOperator,
        CustomerField: rest.CustomerField,
        condition: rest.condition, // giữ condition nếu cần
        value: formatConditionValueDate(rest.value),
      })
    );
};

export const getSyncListCustomerGroupByFilter = async (
  limit: number = 1000000, offset: number = 0, listFilter: IConditionSync[]
) => {
  const path = "/group-customer/"
  const params = {
    limit, offset, listFilter: JSON.stringify(listFilter)
  }
  const result: ResponseSuccessTotal = await axiosClientList.post(
    path, params
  );
  return result;
}



